import type { ISbStoryData } from '@storyblok/js';
import type { PageNewsStoryblok } from '~/.storyblok/types/PageNewsStoryblok';

export function isPageNews(story: ISbStoryData): story is ISbStoryData<PageNewsStoryblok> {
    const content = story.content;

    if (!content || typeof content !== 'object') {
        return false;
    }

    if (!('component' in content) || content.component !== 'PageNews') {
        return false;
    }

    if (!('_uid' in content) || typeof content._uid !== 'string') {
        return false;
    }

    return true;
}
